<template>
  <div class="cr-cart isOpen">
    <div class="cr-container">
      <div v-if="basketLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
      <div v-if="basketError" class="mc-error">{{ basketError }}</div>
      <template v-if="basketLoaded && basket.quantity> 0" >

            <div class="cr-cart__top">
              <div v-if="basket.order_min > 0 && basket.price < basket.order_min" class="cr-cart__message cr-message cr-message--notification">
                Минимальная сумма заказа - {{ basket.order_min }} ₽
              </div>
              <div class="cr-cart__tools">
                    <span class="cr-cart__products-total">
                        {{basket.quantity}} {{ num_word(basket.quantity, ['товар', 'товара', 'товаров']) }}
                    </span>
                <div class="cr-cart__tools-bottom">
                  <button @click="clearBasket" class="cr-button-icon cr-button-icon--red">
                    Очистить корзину
                    <svg class="cr-button-icon__icon" width="14" height="14" viewBox="0 0 14 14">
                      <use xlink:href="/assets/img/svg/sprite.svg#icon-cross"></use>
                    </svg>
                  </button>
                  <button @click="toggleAll"
                          class="cr-cart__toggle-button cr-button-icon js-close-all isActive" type="button">
                                <span class="cr-button-icon__text" data-alt="Развернуть все">
                                    Свернуть все
                                </span>
                    <svg class="cr-button-icon__icon" width="14" height="14" viewBox="0 0 14 14">
                      <use xlink:href="/assets/img/svg/sprite.svg#arrow-chevron-down"></use>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <ul class="cr-cart__category-list accordion">
              <li v-for="(section, index) in basket_items" class="cr-cart__category-item accordion__item  is-active"
                  :ref="`accordionItem${index}`"
                  :key="index"
              >
                <button @click="toggleAccordion(index)"
                        class="cr-cart__trigger accordion__trigger" type="button">
                            <span class="cr-cart__trigger-name">
                                {{basket.sections[index]}}
                                <span class="cr-cart__trigger-count">
                                    {{section.length}} {{ num_word(section.length, ['товар', 'товара', 'товаров']) }}
                                </span>
                            </span>
                  <svg class="cr-cart__trigger-icon" width="24" height="24" viewBox="0 0 24 25">
                    <use xlink:href="/assets/img/svg/sprite.svg#arrow-chevron-up"></use>
                  </svg>
                </button>
                <div class="accordion__body">
                  <div class="cr-cart__inner">
                    <ul class="cr-cart__products-list">
                      <li v-for="item in section" class="cr-cart__products-item">
                        <ProductItem :product="item.product" :isBasket="true"></ProductItem>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
            </ul>
            <div class="cr-cart__summary cr-summary">
              <dl class="cr-summary__list">
                <div class="cr-summary__item cr-summary__item--strong">
                  <dt class="cr-summary__term">
                    Итого
                  </dt>
                  <dd class="cr-summary__value">
                    {{ formatPrice(basket.price) }} ₽
                  </dd>
                </div>
                <div v-if="basket.discount > 0" class="cr-summary__item">
                  <dt class="cr-summary__term">
                    Итого без скидки
                  </dt>
                  <dd class="cr-summary__value">
                    {{ basket.full_price }} ₽
                  </dd>
                </div>
                <div v-if="basket.discount > 0" class="cr-summary__item">
                  <dt class="cr-summary__term">
                    Скидка
                  </dt>
                  <dd class="cr-summary__value">
                    {{ formatPrice(basket.discount) }} ₽
                  </dd>
                </div>
                <div class="cr-summary__item">
                  <dt class="cr-summary__term">
                    Наименований
                  </dt>
                  <dd class="cr-summary__value">
                    {{ basket.quantity }}
                  </dd>
                </div>
              </dl>
              <div class="cr-summary__bottom">
                <a v-if="!basket.order_min ||  basket.price >= basket.order_min" class="cr-button" @click="toOrder">
                            <span class="cr-button__text">
                                Перейти к оформлению
                            </span>
                </a>
              </div>
            </div>
      </template>
      <template v-if="basketLoaded && basket.quantity == 0">
        <p>Ваша корзина пуста</p>
      </template>
    </div>
  </div>

  <div class="cr-modal" :class="{isOpen: authModal}" id="loginModal">
    <div class="cr-modal__outer">
      <div class="cr-modal__inner">
        <div class="cr-modal__heading">
          <button @click="authModal=false" class="cr-modal__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
            <svg class="cr-modal__close-icon" width="30" height="30" viewBox="0 0 30 30">
              <use xlink:href="/assets/img/svg/sprite.svg#icon-cross-1"></use>
            </svg>
          </button>
          <div class="cr-modal__title">
            Войдите, чтобы оформить заказ
          </div>
        </div>
        <div class="cr-modal__bottom">
          <router-link to="/auth/" class="cr-button" type="button">
                            <span class="cr-button__text">
                                Войти
                            </span>
          </router-link>
          <router-link to="/registration/" class="cr-button cr-button--light js-button-close" type="button">
                            <span class="cr-button__text">
                                Отправить заявку на регистрацию
                            </span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import num from "../mixin/num.vue";
import ProductItem from "@/views/components/ProductItem.vue";
import product from "@/mixin/product.vue";
export default {
  data() {
    return {
      activeAccordions: [],
      authModal: false,
    }
  },
  mixins: [num, product],
  mounted() {

  },
  created() {
    this.fetchBasket();
    this.fetchCounterData();
  },
  computed: {
    ...mapGetters('basket', [
      'basket',
      'basket_items',
      'basketLoading',
      'basketError',
      'basketLoaded',
    ]),
    ...mapGetters([
      'isAuth',
    ]),
  },
  components: {ProductItem},
  methods: {
    ...mapActions('basket', [
      'fetchBasket',
        'addToFavorite',
        'removeFromCart',
        'setQuantity',
        'addToBasket',
        'clearBasket'
    ]),
    ...mapActions('counter', [
      'fetchCounterData'
    ]),
    toggleAccordion(index) {
      // Получаем DOM элемент из массива refs
      const accordionItem = this.$refs[`accordionItem${index}`][0];
      const accordionBody = accordionItem.querySelector('.accordion__body');
      const isActive = accordionItem.classList.contains('is-active');

      if (isActive) {
        // Закрываем аккордеон
        const height = accordionBody.scrollHeight;
        accordionBody.style.height = `${height}px`;

        // Форсируем reflow
        accordionBody.offsetHeight;

        accordionBody.style.height = '0px';
        accordionItem.classList.remove('is-active');
      } else {
        // Открываем аккордеон
        accordionItem.classList.add('is-active');
        const height = accordionBody.scrollHeight;
        accordionBody.style.height = `${height}px`;

        // После завершения анимации устанавливаем height: auto
        setTimeout(() => {
          accordionBody.style.height = 'auto';
        }, 300);
      }
    },

    toggleAll() {
      const isCloseAll = this.$el.querySelector('.js-close-all').classList.contains('isActive');
      const accordionItems = this.$el.querySelectorAll('.accordion__item');

      accordionItems.forEach((item) => {
        const body = item.querySelector('.accordion__body');

        if (isCloseAll) {
          // Закрываем все
          const height = body.scrollHeight;
          body.style.height = `${height}px`;
          body.offsetHeight; // force reflow
          body.style.height = '0px';
          item.classList.remove('is-active');
        } else {
          // Открываем все
          item.classList.add('is-active');
          const height = body.scrollHeight;
          body.style.height = `${height}px`;
          setTimeout(() => {
            body.style.height = 'auto';
          }, 300);
        }
      });

      const button = this.$el.querySelector('.js-close-all');
      button.classList.toggle('isActive');
      const text = button.querySelector('.cr-button-icon__text');
      text.textContent = isCloseAll ? 'Развернуть все' : 'Свернуть все';
    },

    toOrder() {
      if (this.isAuth) {
        this.$router.push('/order/');
      }
      else
        this.authModal = true;
    }
  },
}
</script>

